import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FCLink from '../fc_link/fc_link';

/* eslint-disable */
class Top50Card extends Component {
  pad2(n) {
    const number = typeof n === 'string' ? parseInt(n) : n;
    return (number < 10 ? '0' : '') + number;
  }

  renderImage(source, slide, rank) {
    if (['portrait', 'square'].includes(this.props.layout)) {
      const imageName = `${this.pad2(slide)}-${this.pad2(rank)}`;
      const imageSrc = `https://images.fastcompany.net/image/upload/wp-cms/uploads/2020/03/${imageName}.png`;
      return (
        <div className="top-50-shuffle__image-container">
          <img className="top-50-shuffle__image" src={imageSrc} alt="" />
        </div>
      );
    }
    return null;
  }

  render() {
    const { customFields = {}, featured_image = {}, slideIndex, config, link } = this.props;
    const { source = '' } = featured_image;
    const { most_innovative_companies = {} } = customFields;
    const { company = '', reason = '', rank = '' } = most_innovative_companies;

    return (
      <div
        className={`top-50-shuffle__card top-50-shuffle__card--${
          this.props.layout
        }`}
      >
        <FCLink config={config} to={link} title={company} className="top-50-shuffle__link">
          {this.renderImage(source, slideIndex + 1, rank)}
          <span className="top-50-shuffle__digit">{this.pad2(rank)}</span>
          <div>
            <button className="mic-2020__button">
              <span>{company}</span>
            </button>
          </div>
          <span className="top-50-shuffle__title">
            {reason}
          </span>
        </FCLink>
      </div>
    );
  }
}

Top50Card.propTypes = {
  layout: PropTypes.string,
  slideIndex: PropTypes.number,
  config: PropTypes.shape({}).isRequired,
};

export default Top50Card;
